import { dpr } from './utils';

import imgObj from './netImg';

const imgUrlList = Object.assign(imgObj);// 所有图片

// 设置图片路径，优先@2x图，找不到取@1x图
export const getImageUrl = (key) => {
    if (imgUrlList[key + `@${dpr}x`]) {
        return imgUrlList[key + `@${dpr}x`];
    } else if (imgUrlList[key + '@2x']) {
        return imgUrlList[key + '@2x'];
    } else if (imgUrlList[key]) {
        return imgUrlList[key];
    }
};
